"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15 5c-.28 0-.53.11-.71.29L8 11.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l7-7A1.003 1.003 0 0015 5z"];
//# sourceMappingURL=small-tick.js.map